import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BACK_BUTTON } from "@/constants/testIds";

/**
 * Consistent back navigation. In RTL, "back" visually points right (→).
 * Uses SPA history when available (react-router tracks location.key),
 * else routes to `fallback` — safer than window.history.length which is
 * unreliable across browsers when the app is opened in a new tab.
 */
export const BackButton = ({
  fallback = "/",
  label = "رجوع",
  testId = BACK_BUTTON.root,
  className = "",
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // react-router assigns 'default' to the initial entry key; any subsequent
    // in-app navigation replaces it, letting us detect internal history.
    if (location.key && location.key !== "default") {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:border-gray-300 hover:bg-gray-50 hover:text-gray-900 ${className}`}
    >
      <ArrowRight className="h-4 w-4" strokeWidth={1.75} />
      <span>{label}</span>
    </button>
  );
};
